import React from "react";
import { Building2, Siren, CalendarCheck, Phone, MessageCircle, ArrowUpRight } from "lucide-react";
import { WHATSAPP_NUMBER_E164, ReviewsStrip } from "@/components/SocialLinks";

const track = (name) => window.gtag?.("event", name, { location: "two_paths" });
const WA_HREF = `https://wa.me/${WHATSAPP_NUMBER_E164}?text=${encodeURIComponent("Emergency A/C callout — site address: ")}`;

const TwoPaths = ({ onBook }) => (
  <section className="py-16 md:py-20 bg-white" data-testid="two-paths">
    <div className="max-w-editorial mx-auto px-6 md:px-10 lg:px-12">
      <div className="font-mono text-[11px] tracking-overline uppercase text-muted mb-6">[ How can we help today? ]</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-paper-warm border border-black/8 rounded-md p-8 md:p-10 flex flex-col" data-testid="two-paths-commercial">
          <Building2 className="h-6 w-6 text-brand mb-6" />
          <h2 className="font-display font-bold text-[1.6rem] md:text-[2rem] tracking-tightest leading-tight">Commercial contracts</h2>
          <p className="mt-3 text-[15px] text-muted-foreground leading-relaxed max-w-md">
            Planned maintenance and compliance for offices, schools, hotels and multi-site estates. One accountable team, fixed-price quotes.
          </p>
          <div className="flex flex-wrap gap-3 mt-auto pt-8">
            <button type="button" onClick={() => { track("two_paths_commercial_book"); onBook(); }} data-testid="two-paths-commercial-book"
              className="inline-flex items-center gap-2 px-5 py-3 bg-brand text-white font-semibold text-[14px] rounded-sm hover:bg-accent transition-colors">
              Book a free site survey <CalendarCheck className="h-4 w-4" />
            </button>
            <a href="#health-check" onClick={() => track("two_paths_commercial_healthcheck")} data-testid="two-paths-commercial-healthcheck"
              className="inline-flex items-center gap-2 px-5 py-3 border border-ink text-ink font-semibold text-[14px] rounded-sm hover:bg-ink hover:text-white transition-colors">
              60-second health check <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
          <div className="mt-4"><ReviewsStrip testId="two-paths-reviews" /></div>
        </div>
        <div className="bg-ink text-white rounded-md p-8 md:p-10 flex flex-col" data-testid="two-paths-emergency">
          <Siren className="h-6 w-6 text-accent mb-6" />
          <h2 className="font-display font-bold text-[1.6rem] md:text-[2rem] tracking-tightest leading-tight text-white">Emergency A/C &amp; refrigeration</h2>
          <p className="mt-3 text-[15px] text-white/70 leading-relaxed max-w-md">
            Cooling down, cold room failing or a refrigerant leak? Call now. 24/7 across London and the M25 corridor.
          </p>
          <div className="flex flex-wrap gap-3 mt-auto pt-8">
            <a href="tel:01895919333" onClick={() => track("two_paths_emergency_call")} data-testid="two-paths-emergency-call"
              className="inline-flex items-center gap-2 px-5 py-3 bg-accent text-white font-semibold text-[14px] rounded-sm hover:bg-white hover:text-ink transition-colors">
              <Phone className="h-4 w-4" /> Call 01895 919 333
            </a>
            <a href={WA_HREF} target="_blank" rel="noopener noreferrer" onClick={() => track("two_paths_emergency_whatsapp")} data-testid="two-paths-emergency-whatsapp"
              className="inline-flex items-center gap-2 px-5 py-3 border border-white/30 text-white font-semibold text-[14px] rounded-sm hover:border-white transition-colors">
              <MessageCircle className="h-4 w-4" /> WhatsApp us
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default TwoPaths;
